import React from 'react';
import { Stack } from '@moda/om';
import { noop } from '@moda/portal-stanchions';
import { DesignerListingPageFragment } from '../../generated/types';
import { SidebarLayout, Sidebar, Content } from '../SidebarLayout';
import { PageFilter } from '../PageFilter';
import { PLPBreadcrumbs } from '../PLPBreadcrumbs';

import './DesignerListingDesktop.scss';

interface Props {
  headerText: string;
  queryResult?: DesignerListingPageFragment | null;
  children?: React.ReactNode;
}

export const DesignerListingDesktop: React.FC<Props> = ({ headerText, queryResult, children }) => (
  <>
    <PLPBreadcrumbs />
    <Stack space={6}>
      <h1 className="DesignerListingDesktop__header">{headerText}</h1>
      <SidebarLayout>
        <Sidebar>
          <PageFilter
            attributes={[]}
            availability={queryResult?.availability ?? null}
            categoryTree={queryResult?.categoryTree ?? null}
            colors={[]}
            designers={[]}
            sizes={[]}
            saleTags={[]}
            showPriceFilter={false}
            showCounts={false}
            onClose={noop}
          />
        </Sidebar>
        <Content>{children}</Content>
      </SidebarLayout>
    </Stack>
  </>
);
